module.exports = __webpack_public_path__ + "static/cube15-bc86a88b7d27ebc537a77f1ef6d28329.svg";